import AudioManager from "../../../../manager/audio_manager";




export default class ChatEmojiSound {
    static path:string = 'package/table/chat_emoji/sound/';

    

    //暂停音乐
    static stopSound(audioID:number){
        cc.audioEngine.stop(audioID);
    }
    
    static playSound(name:string){

        AudioManager.instance.playSound(ChatEmojiSound.path + name, false, null)
        
    }
    
    //发牌
    static playBomb(str:string){
        ChatEmojiSound.playSound(str);
    }

    //发牌
    static playFly(str:string){
        ChatEmojiSound.playSound(str);
    }
    
}
